<div style="position:sticky; top:-1px; z-index:100;">
  <app-dp-bottom-sheet-closer (closeClicked)="closesheet()" >
  </app-dp-bottom-sheet-closer>
</div>

<div class="are-you-updated-sheet">
  <div class="d-flex justify-content-between" style="width:100%">
    <div class='head-text'>Are you updated?</div>
  </div>
    
    @for(user of users;track user){
      <div class="mobile-view-data-container">

        <div class="d-flex justify-content-between">
          <span class="header-text">Full name</span>
          <span class="data-text">{{ user.philName || "-" }}</span>
        </div>
  
  
        <div class="d-flex justify-content-between">
          <span class="header-text">SL. no</span>
          <div class="serial-no">
            <span class="serial-no-text">{{ user.mk || "-" }}</span>
          </div>
        </div>
  
        <div class="d-flex justify-content-between">
          <span class="header-text">Status</span>
          <span class="data-text d-flex justify-content-end align-items-center gap-2" >
            <span class=" mb-1">

              @if(user.rs=='DA Approved'){
                <img src="../../assets/images/approve.svg" alt=""/>
              }@else {
                <img src="../../assets/images/pending.svg" alt=""/>
              }

            </span>
            {{ user.rs || "-" }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span class="header-text">State</span>
          <span class="data-text ">{{ user.st || "-" }}</span>
        </div>
  
        <div class="d-flex justify-content-between">
          <span class="header-text w-25">District</span>
          <span class="data-text ">{{ user.dn || "-"}}</span>
        </div>
  
  
        <div class="d-flex justify-content-between">
          <span class="header-text">Istavrity date</span>
          <span class="data-text">{{ user.lastIvDate || "-" }}</span>
        </div>
  
  </div>
        
    
}

  </div>